import Collection from './generic/collection'
import { FetchData } from './utils/fetchData'
import Preloader from './preloader'

const instance = '[data-js-dell-from-cart]'
const tableWrapperSelector = '[data-table-wrapper]'
export default class DellFromCart {
  instance = instance

  constructor (instance) {
    this.instance = instance
    this.bindEvents()
  }

  async dell (e) {
    e.stopImmediatePropagation()
    e.preventDefault()
    const confirmText = e.target.closest(instance).dataset.jsConfirm

    if (confirm(confirmText)) {
      let linkId = e.target.closest(instance).id
      let ajaxUrl = e.target.closest(instance).dataset.jsAjaxUrl
      let request = await FetchData.postData({ data: linkId }, ajaxUrl)
      const tableWrapper = e.target.closest(tableWrapperSelector) || document
      try {
        if (request.success) {
          $(tableWrapper).trigger('trigger::dell-item-from-cart', [e.target.closest('.card-title').querySelector('[data-item-price]')])
          e.target.closest('.card').remove()
        }
        Preloader.hide()
      } catch (err) {
        Preloader.hide()
      }

    }
  }

  bindEvents () {
    this.instance.addEventListener('click', (e) => this.dell(e))
  }
}

export class DellFromCartCollection extends Collection {
  constructor () {
    super(instance, DellFromCart)
    this.init()
  }

  init () {
    $(instance).each((index, el) => {
      this.collection = new DellFromCart(el)
    })
  }

}
